import { IRowVersionableDto } from '../common/rowVersionable';

export class AddTenderTeamMemberDto {
    firstName: string;
    lastName: string;
    emailStart: string;
    fileAccess: boolean;
}

export class SetTenderTeamMemberFileAccessDto {
    id: number;
    fileAccess: boolean;
}

export class DeleteTenderTeamMemberDto {
    id: number;
}

export class GetTeamMemberDetailsDto implements IRowVersionableDto {
    rowVersion: string;
    tokenError: boolean;
    id: number;
    emailVerified: boolean;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
}

export class TenderTeamMemberSummaryDto implements IRowVersionableDto {
    id: number;
    name: string;
    email: string;
    hasAcceptedInvite: boolean;
    rowVersion: string;
    fileAccess: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/tender.team.members/tender.team.member.models.ts